/**
 * Registry of features that show a one-shot "Try" badge + stepped walkthrough
 * on Ask Puntt home. First consumer: Deep Artwork Review (`artwork_review`).
 */

import howItWorksPreview from "./assets/deep-review-walkthrough-how-it-works.png";
import introPreview from "./assets/deep-review-walkthrough-intro.png";

export type TryStepKind = "intro" | "upload";

export type TryIntroStep = {
  kind: "intro";
  /** i18n key under tryWalkthrough.<featureId>.steps.<stepKey> */
  stepKey: string;
  /** Full-bleed hero for the step. Alt copy is `steps.<stepKey>.previewAlt`. */
  previewSrc: string;
};

export type TryUploadStep = {
  kind: "upload";
  stepKey: string;
};

export type TryStep = TryIntroStep | TryUploadStep;

export type TryFeatureConfig = {
  featureId: string;
  /** SkillCards / WORKFLOW_CARDS id that owns the Try badge. */
  cardId: string;
  launchReviewMode: "deep" | "standard";
  steps: readonly TryStep[];
};

export const ARTWORK_REVIEW_TRY_FEATURE: TryFeatureConfig = {
  featureId: "artwork_review",
  cardId: "artwork_review",
  launchReviewMode: "deep",
  steps: [
    {
      kind: "intro",
      stepKey: "intro",
      previewSrc: introPreview,
    },
    {
      kind: "intro",
      stepKey: "howItWorks",
      previewSrc: howItWorksPreview,
    },
    {
      kind: "upload",
      stepKey: "upload",
    },
  ],
};

export const TRY_FEATURES_BY_CARD_ID: Record<string, TryFeatureConfig> = {
  artwork_review: ARTWORK_REVIEW_TRY_FEATURE,
};

export function getTryFeatureForCard(
  cardId: string,
): TryFeatureConfig | undefined {
  return TRY_FEATURES_BY_CARD_ID[cardId];
}
